// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cleaning-and-repairs {
  padding-left: 2rem;
  padding-right: 5rem;
  width: 100%;
}

.cleaning-and-repairs h1 {
  display: flex;
  justify-content: center;
  color: #247a97;
  font-size: 3.5rem;
  margin: 5rem auto;
  font-style: italic;
  align-items: center;
}

.cleaning-and-repairs .landing-quote p {
  font-size: 1.75rem;
  text-align: center;
}

.two-columns {
  display: flex;
  justify-content: center;
  margin: 5rem auto;
}

.left-column,
.right-column {
  width: 50%;
}

.left-column img,
.right-image img,
.last-image {
  max-width: 100%;
  height: auto;
  border-radius: 15px;
}

.right-column p,
.image-and-paragraph p,
.two-paragraphs p {
  text-indent: 2rem;
  text-align: left;
  font-size: 1.25rem;
  margin: 0 3rem;
  line-height: 1.7;
}

.image-and-paragraph,
.two-paragraphs-and-image {
  display: flex;
  align-items: center;
  margin: 2rem auto;
}

.image-and-paragraph img {
  width: 40%;
}

.image-and-paragraph p,
.two-paragraphs {
  width: 60%;
}

/* Responsive Adjustments */
@media screen and (max-width: 600px) {
  .cleaning-and-repairs,
  .cleaning-and-repairs p,
  .right-column p,
  .five-images-and-paragraphs p,
  .five-images-and-paragraphs,
  .two-paragraphs p,
  .image-and-paragraph img,
  .image-and-paragraph p {
    font-size: 1.5rem;
    margin: 1rem auto;
    width: 90%;
    text-align: justify;
  }

  .two-columns,
  .left-column,
  .right-column,
  .image-and-paragraph,
  .two-paragraphs-and-image {
    flex-direction: column;
    width: 100%;
  }

  .left-column img,
  .right-image img {
    margin: auto;
  }
}

@media screen and (max-width: 992px) {
  .cleaning-and-repairs .landing-quote {
    flex-direction: column;
    text-align: center;
  }
}

@media screen and (min-width: 1181px) {
  .right-column p,
  .five-images-and-paragraphs p,
  .image-and-paragraph p,
  .two-paragraphs p {
    font-size: 1.5rem;
    text-indent: 2.5rem;
    line-height: 1.8;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/CleaningAndRepairs.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;;EAGE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;EAGE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE;;;;;;;;IAQE,iBAAiB;IACjB,iBAAiB;IACjB,UAAU;IACV,mBAAmB;EACrB;;EAEA;;;;;IAKE,sBAAsB;IACtB,WAAW;EACb;;EAEA;;IAEE,YAAY;EACd;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;;;;IAIE,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;EAClB;AACF","sourcesContent":[".cleaning-and-repairs {\n  padding-left: 2rem;\n  padding-right: 5rem;\n  width: 100%;\n}\n\n.cleaning-and-repairs h1 {\n  display: flex;\n  justify-content: center;\n  color: #247a97;\n  font-size: 3.5rem;\n  margin: 5rem auto;\n  font-style: italic;\n  align-items: center;\n}\n\n.cleaning-and-repairs .landing-quote p {\n  font-size: 1.75rem;\n  text-align: center;\n}\n\n.two-columns {\n  display: flex;\n  justify-content: center;\n  margin: 5rem auto;\n}\n\n.left-column,\n.right-column {\n  width: 50%;\n}\n\n.left-column img,\n.right-image img,\n.last-image {\n  max-width: 100%;\n  height: auto;\n  border-radius: 15px;\n}\n\n.right-column p,\n.image-and-paragraph p,\n.two-paragraphs p {\n  text-indent: 2rem;\n  text-align: left;\n  font-size: 1.25rem;\n  margin: 0 3rem;\n  line-height: 1.7;\n}\n\n.image-and-paragraph,\n.two-paragraphs-and-image {\n  display: flex;\n  align-items: center;\n  margin: 2rem auto;\n}\n\n.image-and-paragraph img {\n  width: 40%;\n}\n\n.image-and-paragraph p,\n.two-paragraphs {\n  width: 60%;\n}\n\n/* Responsive Adjustments */\n@media screen and (max-width: 600px) {\n  .cleaning-and-repairs,\n  .cleaning-and-repairs p,\n  .right-column p,\n  .five-images-and-paragraphs p,\n  .five-images-and-paragraphs,\n  .two-paragraphs p,\n  .image-and-paragraph img,\n  .image-and-paragraph p {\n    font-size: 1.5rem;\n    margin: 1rem auto;\n    width: 90%;\n    text-align: justify;\n  }\n\n  .two-columns,\n  .left-column,\n  .right-column,\n  .image-and-paragraph,\n  .two-paragraphs-and-image {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .left-column img,\n  .right-image img {\n    margin: auto;\n  }\n}\n\n@media screen and (max-width: 992px) {\n  .cleaning-and-repairs .landing-quote {\n    flex-direction: column;\n    text-align: center;\n  }\n}\n\n@media screen and (min-width: 1181px) {\n  .right-column p,\n  .five-images-and-paragraphs p,\n  .image-and-paragraph p,\n  .two-paragraphs p {\n    font-size: 1.5rem;\n    text-indent: 2.5rem;\n    line-height: 1.8;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
